import { Badge } from "@/components/ui/badge";
import type { MdfRequestStatus } from "./types";

// Single source of truth for status presentation across the MDF list page
// (request cards) and the detail page (header). The 6 statuses correspond
// to the mdf_request_status enum widened by migration 0067.

type Variant = "default" | "secondary" | "destructive" | "outline";

const MAP: Record<MdfRequestStatus, { variant: Variant; label: string }> = {
  draft: { variant: "outline", label: "Draft" },
  pending: { variant: "outline", label: "Pending review" },
  approved: { variant: "default", label: "Approved" },
  spent: { variant: "secondary", label: "Spent" },
  declined: { variant: "destructive", label: "Declined" },
  cancelled: { variant: "secondary", label: "Cancelled" },
};

export function MdfStatusBadge({ status }: { status: MdfRequestStatus }) {
  const entry = MAP[status] ?? { variant: "outline" as const, label: status };
  return <Badge variant={entry.variant}>{entry.label}</Badge>;
}
